import React from 'react';

import { useThemeColor } from '../../../hooks/useThemeColor';

// import images and icons

const moonDarkIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/ThemeChangerIcons/moon-dark-icon.svg";
const sunLightIcon = process.env.PUBLIC_URL + "/Assets/Images/Icons/ThemeChangerIcons/sun-light-icon.svg";

const ThemeChanger = () => {
    const { colorMode, changeThemeMode, } = useThemeColor();
    return (
        <>
            <span
                className="pointer"
                onClick={() => {
                    changeThemeMode();
                }}>
                {
                    (colorMode === "light") ?
                        <img src={moonDarkIcon} alt="moon" width={"28px"} />
                        :
                        <img src={sunLightIcon} alt="sun" width={"28px"} />
                }
            </span>
        </>
    );
};

export default ThemeChanger;